<template lang="pug">
.vfooter
  .footer-wrap
    .container
      .contact
        p
          a.mail(href='/about') 关于我们
          | 　|　
          a.mail(href='/volunteers') 志愿者招募
        p
          img(src='../assets/imgs/tel.svg')
          | 联系小助手：132 6332 1278
        p
          a.mail(href='mailto:thefrontier@geekpark.net')
            img(src='../assets/imgs/mail.svg')
            | thefrontier@geekpark.net
        p.site Powered by <a href="http://www.geekpark.net" target="_blank">GeekPark</a>
      .follow
        p
          img(src='../assets/imgs/qrcode.jpg', alt='前沿社公众号')
          | <br>关注前沿社公众号<br>开启认知之旅
  .footer-copyright
    .container
      p 京ICP备 13016923号-2   京公网安备 110105001682号
</template>

<script>
export default {
  name: 'vfooter',
  data () {
    return {
    }
  }
}
</script>

<style lang="stylus">
@import '../assets/css/var'

.vfooter
  text-align center
  color #fff

  a
    color #fff
    &:hover
      color #5FC4FF

  .footer-wrap
    background #000
    padding 25px 0
    text-align right
    .contact
      float left
      font-size 16px
      text-align left
      line-height 2.4em
      p
        img
          width 1.5em
          vertical-align middle
          padding-right .8em
        &.site
          font-weight normal
          font-family "BebasNeue"
          font-size 1.2em
          letter-spacing .1em
          a
            font-weight bold
    .follow
      p
        text-align center
        display inline-block
        font-size 12px
        line-height 1.5em
        img
          width 100px
          margin 0px 20px
  .footer-copyright
    background #363636
    text-align left
    p
      color #999
      font-size 14px
      line-height 42px
      text-align left

@media $media
  .vfooter
    .footer-wrap
      .contact
        font-size 12px
        line-height 3em
      .follow
        p
          img
            margin-left 0
            margin-right 0
  .footer-copyright
    display none

@media only screen and (max-width: 350px)
  .vfooter
    .footer-wrap
      .contact
        img
          display none
</style>



// WEBPACK FOOTER //
// Vfooter.vue?490f317d